import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import PlusMinus from './plusMinus.jsx';

class BotLevel extends React.Component {

  genText() {
    var text = "beginner";
    if (this.props.value == 2)
      text = "easy";
    else if (this.props.value == 3)
      text = "medium";
    else if (this.props.value == 4)
      text = "hard";
    else if (this.props.value == 5)
      text = "nightmare";

    return "(" + text + ")";
  }

	render() {
    return (
      <span>
        <PlusMinus setValue={this.props.setValue} value={this.props.value}/> 
        <br/>
        { this.genText() }
      </span>
    );
  }
}

BotLevel.propTypes = {
  setValue: PropTypes.func,
  value: PropTypes.number,
};

export default BotLevel;